import { SignupForm } from '@/components/SignupForm';
import { HeaderSection } from '@/sections/HeaderSection';
import { usePostHog } from 'posthog-js/react';
import { useEffect, useRef, useState } from 'react';
import './styles.scss';

const postHogBookingVisitEvent = 'pw_landing_page_booking_visit';
const postHogCalendarRedirectEvent = 'pw_landing_page_calendar_redirect';

export const BookingPage = () => {
  const buttonPositionRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFixed, setIsFixed] = useState(false);
  const postHog = usePostHog();

  useEffect(() => {
    if (postHog) {
      postHog.capture(postHogBookingVisitEvent);
    }
  }, [postHog]);

  useEffect(() => {
    const element = buttonPositionRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFixed(!entry?.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -100px 0px',
      }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, []);

  const handleContactClick = () => {
    const calendarElement = document.getElementById('calendar-section');
    if (calendarElement) {
      calendarElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCalendarClick = () => {
    if (postHog) {
      postHog.capture(postHogCalendarRedirectEvent, {
        calendar_url: 'https://calendar.app.google/YLh7RiRkHH8pBcLx5',
      });
    }
  };

  return (
    <>
      <main className='booking-main'>
        <HeaderSection onContactClick={handleContactClick} withButton={false} />

        <section id='calendar-section' className='content-section'>
          <div className='container'>
            <div className='content-wrapper'>
              <div className='video-wrapper'>
                <video
                  controls
                  src='PlayWall at MyTown.mp4'
                  className='video'
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload='auto'
                />
              </div>
              <div className='text-content-wrapper'>
                <h1 className='main-heading'>
                  This Isn't Ad Space.
                  <br />
                  It's{' '}
                  <span className='highlight-green'>
                    Performance-Driven Interaction
                  </span>
                </h1>
                <p className='description-text'>
                  PlayWall turns physical attention into engagement,
                  user-created content, and real-world conversions - with
                  trackable impact.
                </p>
                <div
                  ref={buttonPositionRef}
                  className='calendar-button-position'
                >
                  <div
                    className={[
                      'calendar-button-wrapper',
                      isFixed ? 'fixed' : 'sticky',
                    ].join(' ')}
                  >
                    <a
                      href='https://calendar.app.google/YLh7RiRkHH8pBcLx5'
                      target='_blank'
                      rel='noopener noreferrer'
                      className='booking-button'
                      onClick={handleCalendarClick}
                    >
                      Book a 15-minute demo
                    </a>
                  </div>
                </div>
                <div className='signup-section'>
                  <p className='signup-text-1'>Not ready to book?</p>
                  <p className='signup-text-2'>
                    Leave your email and we'll get in touch
                  </p>
                  <SignupForm inputRef={inputRef} />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='cta-footer-section'>
          <div className='container gif-container'>
            <div className=''>
              <img
                src='cta-section/animation.gif'
                alt='PlayWall Logo Animation'
                className='logo-animation'
              />
              <span className='text'>
                Malaysia's first interactive OOH network. <br /> On
                {String.fromCharCode(8209)}ground . Measurable. Finally!
              </span>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
